import { NavItem } from '@libs/models/nav-item.interface';
import { IAnnex } from '@libs/models/models';

export const navItems: NavItem[] = [
  {
    label: 'nav.loan',
    route: '/main/loan',
    img: {
      url: '/assets/images/icons/icon-loan.svg',
      width: '22px',
      height: '18px',
    },
  },
  {
    label: 'nav.loanHistory',
    route: '/main/history',
    img: {
      url: '/assets/images/icons/icon-loan-history.svg',
      width: '26px',
      height: '18px',
    },
  },
  {
    label: 'nav.profile',
    route: '/main/profile',
    img: {
      url: 'assets/images/icons/icon-profile.svg',
      width: '22px',
      height: '22px',
    },
  },
  {
    label: 'nav.UPLOAD_DOCUMENT',
    route: '/main/upload',
    img: {
      url: '/assets/images/icons/icon-load-document.svg',
      width: '18px',
      height: '22px',
    },
  },
];

export const websiteItems: NavItem[] = [
  {
    label: 'NAVIGATION.HOW_GET_LOAN',
    route: '/borrow',
  },
  {
    label: 'NAVIGATION.HOW_PAY_LOAN',
    route: '/repay',
  },
  /* {
     label: 'NAVIGATION.COOPERATION',
     route: '/cooperation',
   },*/
  {
    label: 'NAVIGATION.CONTACTS',
    route: '/contacts',
  },
  {
    label: 'NAVIGATION.ABOUT_US',
    route: '/about-us',
  },
];

export const annexItems: IAnnex[] = [
  {
    label: 'FOOTER.ANNEX.APP_STORE',
    link: '',
    icon: '/assets/images/landing/icons/icon-apple.png',
  },
  {
    label: 'FOOTER.ANNEX.PAY_STORE',
    link: '',
    icon: '/assets/images/landing/icons/icon-playmarket.png',
  },
];
